import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {EXCLUDE_FROM_WIDEVIEW_CLASS, EXCLUDE_FROM_NARROWVIEW_CLASS} from "../../config/constants"

export type ContainerProps = {
    isActive: boolean
    marketingStyles: {linkColour?: string; fontWeight?: string}
    isHidden: boolean
}

export type TitleProps = {
    isActive: boolean
    linkColour?: string
    fontWeight?: string
}

export const Container = styled("li", {
    shouldForwardProp: prop => ["isActive", "marketingStyles", "isHidden"].indexOf(String(prop)) === -1,
})<ContainerProps>`
    background: ${({isActive, theme}) =>
        isActive
            ? theme.uxfabric.components.tab.nav.default.active.backgroundColor
            : theme.uxfabric.components.tab.nav.default.enabled.backgroundColor};
    position: relative;
    list-style: none;
    cursor: pointer;
    flex-shrink: 0;
    height: 100%;
    padding-right: var(--padding, 0);
    padding-left: var(--padding, 0);
    z-index: ${({isActive}) => (isActive ? 4 : 0)};
    display: ${({isHidden}) => (isHidden ? "none" : "block")};
    && a {
        background: ${({isActive, theme}) =>
            isActive ? theme.uxfabric.components.tab.nav.default.active.backgroundColor : "inherit"};
        padding: 0 0.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        color: ${({isActive, theme, marketingStyles: {linkColour}}) =>
            isActive
                ? theme.uxfabric.components.tab.nav.default.active.textColor
                : linkColour || theme.uxfabric.components.tab.nav.default.enabled.textColor} !important;
        text-decoration: none;
        font-size: ${({theme}) => theme.uxfabric.component.tabTextNav.fontSize};
        letter-spacing: 0.0625rem;
        font-family: ${({theme}) =>
            `${theme.uxfabric.component.tabTextNav.fontFamily}, ${FALLBACK_FONT_FAMILY} !important`};
        font-synthesis: initial;
        font-weight: ${({theme, marketingStyles: {fontWeight}}) =>
            fontWeight || theme.uxfabric.component.tabTextNav.fontWeight};
        text-transform: ${({theme}) => theme.uxfabric.component.tabTextNav.textTransform};

        @media (min-width: ${breakpoints.values.xl}px) {
            padding: 0 0.725rem;
        }

        @media (min-width: ${breakpoints.values.lg}px) {
            font-weight: ${({theme, marketingStyles: {fontWeight}}) =>
                fontWeight || theme.uxfabric.component.tabTextNav.fontWeight};
            &:hover > i {
                display: block;
            }
        }

        @media (max-width: ${breakpoints.values.lg - 1}px) {
            i {
                display: ${({isActive}) => (isActive ? "block" : "none")};
            }
        }
        &:focus {
            outline-offset: -2px;
        }

        & div {
            font-family: ${({theme}) =>
                `${theme.uxfabric.component.tabTextNav.fontFamily}, ${FALLBACK_FONT_FAMILY} !important`};
            letter-spacing: ${({theme}) => `${theme.uxfabric.component.tabTextNav.letterSpacing}px`};
            font-size: inherit;
            font-synthesis: initial;
        }
    }

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        &.${EXCLUDE_FROM_NARROWVIEW_CLASS} {
            display: none;
        }
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        &.${EXCLUDE_FROM_WIDEVIEW_CLASS} {
            display: none;
        }
    }
`
export const Title = styled("div", {
    shouldForwardProp: prop => ["isActive", "linkColour"].indexOf(String(prop)) === -1,
})<TitleProps>`
    color: ${({isActive, theme, linkColour}) =>
        isActive
            ? theme.uxfabric.components.tab.nav.default.active.textColor
            : linkColour || theme.uxfabric.components.tab.nav.default.enabled.textColor};
    font-family: ${({theme}) => theme.uxfabric.component.tabTextNav.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.component.tabTextNav.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.tabTextNav.fontWeight};
    line-height: ${({theme}) => theme.uxfabric.component.tabTextNav.lineHeight};
    text-transform: ${({theme}) => theme.uxfabric.component.tabTextNav.textTransform};
    letter-spacing: ${({theme}) => `${theme.uxfabric.component.tabTextNav.letterSpacing}px`};
    font-synthesis: initial;
`

export const PictureComponent = styled("img")`
    max-height: 2.75rem;
`
